// Google Analytics utility
// Работает только при согласии пользователя на аналитические cookies

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Проверяем, дал ли пользователь согласие на аналитические cookies
const hasAnalyticsConsent = () => {
  try {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) return false;
    const preferences = JSON.parse(cookieConsent);
    return preferences.analytics === true;
  } catch (e) {
    return false;
  }
};

// Инициализация Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('Google Analytics ID не настроен. Установите REACT_APP_GA_MEASUREMENT_ID в .env (формат: G-XXXXXXXXXX)');
    return;
  }

  // Проверяем формат ID (должен начинаться с G-)
  if (!GA_MEASUREMENT_ID.startsWith('G-')) {
    console.warn('Неверный формат Google Analytics ID. ID должен начинаться с G- (например: G-XXXXXXXXXX)');
    return;
  }

  if (!hasAnalyticsConsent()) {
    return;
  }

  // Проверяем, не загружен ли уже скрипт
  if (window.gtag && document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
    // GA уже инициализирован, просто обновляем конфигурацию
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    });
    return;
  }

  // Загружаем Google Analytics скрипт
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Инициализируем gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
  });
};

// Отключение Google Analytics (при отзыве согласия)
export const disableGA = () => {
  if (window.gtag) {
    // Отключаем отслеживание
    window.gtag('consent', 'update', {
      analytics_storage: 'denied'
    });
  }
  
  // Удаляем скрипты GA
  const scripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
  scripts.forEach(script => script.remove());
  
  // Очищаем dataLayer
  if (window.dataLayer) {
    window.dataLayer = [];
  }
  delete window.gtag;
};

// Отслеживание просмотра страницы
export const trackPageView = (path) => {
  if (!hasAnalyticsConsent() || !window.gtag) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path || window.location.pathname,
  });
};

// Отслеживание событий
export const trackEvent = (eventName, eventParams = {}) => {
  if (!hasAnalyticsConsent() || !window.gtag) {
    return;
  }

  window.gtag('event', eventName, eventParams);
};

// Отслеживание регистрации
export const trackSignUp = (method = 'email') => {
  trackEvent('sign_up', {
    method: method
  });
};

// Отслеживание входа
export const trackLogin = (method = 'email') => {
  trackEvent('login', {
    method: method
  });
};

// Отслеживание создания задачи
export const trackJobCreated = (modelId, modelName) => {
  trackEvent('job_created', {
    model_id: modelId,
    model_name: modelName
  });
};

// Отслеживание успешной оплаты
export const trackPurchase = (value, currency = 'RUB') => {
  trackEvent('purchase', {
    value: value,
    currency: currency
  });
};
